module.exports = __webpack_public_path__ + "static/media/parallax-form-3.0300c58c.svg";